import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getInputsFavorites,
  getMe,
  getStates,
} from "../../../api";
import empty_box from "../../../images/empty_box.png";
import DetailsModal from "../../inputs/components/details-modal";
import ContactModal from "../../../components/contact_modal";
import { AnimatePresence } from "framer-motion";
import { cities_data, markets_data } from "../../../data";
import { useAuth } from "../../../store/authProvider";
import Client from "../../../utils/client";
import { delete_icon } from "../../../icons/trash";
import { Link } from "react-router-dom";
import { edit_icon } from "../../../icons/edit";
import DeleteModal from "./deleteModal";
import Skelton from "../../../icons/skelton";


function InputsInputs() {
  const { isAuth } = useAuth();
  const [input, setInput] = useState();
  const [showContactModal, setShowContactModal] = useState(false);
 
  const [showModal, setShowModal] = useState(false);
  const [delteModal, setDeleteModal] = useState(false);
  const [item, setItem] = useState();

  const {
    data: myOffers,
    isFetching: offersFetching,
    refetch,
  } = useQuery({
    queryKey: ["my_offers"],
    queryFn: () => getMe(),
    initialData: [],
  });
  const getInput = async (id) => {
    const response = await Client.get(`/inputs/${id}`).then((res) => res.data);
    setInput(response);
    setShowModal(true);
    const user_id = localStorage.getItem("user_id");
    Client.post("/admin/logs", {
      user_id: isAuth ? user_id : null,
      action: "Product View",
      product_type: "Inputs Product",
      product_id: id.toString(),
    });
  };
 
  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });
  const { data: inputsFavorites } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => getInputsFavorites(),
    initialData: [],
    enabled: isAuth,
  });

  if (offersFetching) {
    return (
      <div
        dir="rtl"
        className="my-16 grid grid-cols-1 gap-4 px-0 lg:grid-cols-5 lg:mr-8"
      >
        {[...Array(5).keys()].map((e, i) => (
          <Skelton key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="my-10 px-5 lg:px-7">
      <AnimatePresence>
        {delteModal && (
          <DeleteModal
            setShowDetails={setDeleteModal}
            item={item}
            refetch={refetch}
          />
        )}
        {showModal && (
          <DetailsModal
            offer={input}
            cities_data={cities_data}
            markets_data={markets_data}
            setShowContactModal={setShowContactModal}
            setShowModal={setShowModal}
            states={states}
            favoriteOffers={inputsFavorites}
            type="متوفر"
          />
        )}
        {showContactModal && (
          <ContactModal
            offer={input}
            setShowContactModal={setShowContactModal}
          />
        )}
      </AnimatePresence>
      <h1 className="text-end font-bold text-[24px] my-10">
        مدخلات الإنتاج
      </h1>
      { myOffers?.inputs?.filter((e) => e.status === "active").length ===
        0 ? (
        <div className="flex flex-col h-72 -span-2 mt-10 justify-center items-center text-center lg:col-span-5">
          <div>
            <img src={empty_box} alt=""></img>
          </div>
          <div className="font-bold mt-3">لا توجد مدخلات</div>
          <div className="h-10"></div>
        </div>
      ) : (
        <div className="flex gap-3 justify-end">
          {myOffers?.inputs
            .filter((e) => e.status === "active")
            .map((item) => (
              <div
                className=" w-full lg:w-[13rem] lg:min-w-[13rem] "
                key={item.id}
              >
                <div
                  className="relative  flex flex-row-reverse lg:flex-col items-center justify-evenly overflow-hidden w-full bg-white border-2 border-primary rounded-2xl  h-[8rem] lg:w-auto lg:h-72 min-w-full lg:text-2xl"
                  key={item.id}
                  onClick={() => getInput(item.id)}
                >
                  <img
                    src={item.input_category.image}
                    className="  lg:h-2/4  max-w-[108px]  lg:max-w-full mt-2 "
                    alt=""
                  />
                  <div className="flex w-[160px] gap-2 lg:gap-1 lg:w-auto flex-col text-right  lg:mx-auto lg:font-normal">
                    <div
                      className="flex lg:justify-center items-center"
                      dir="rtl"
                    >
                      {/* {item.type === "buy" && <div className="px-2">مطلوب</div>}  */}
                      <div className="font-bold text-lg my-1">
                        {item.input_category.name}
                      </div>
                    </div>

                    <div className=" mb-1 text-sm font-bold lg:font-normal lg:text-center">
                      {item._state.name}
                    </div>
                  </div>
                  <div className="flex lg:flex-row flex-row items-center justify-between gap-3  align-baseline">
                    <div className="flex items-center flex-row mb-2">
                      <div className="lg:absolute lg:inset-3 flex flex-col gap-6 lg:gap-52">
                        {isAuth &&
                          item.owner === localStorage.getItem("user_id") && (
                            <Link to={`/editInput/${item.id}`}>
                              <div className=" font-bold">{edit_icon}</div>
                            </Link>
                          )}
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setItem(item);
                            setDeleteModal(true);
                          }}
                          className="lg:ml-auto cursor-pointer"
                        >
                          {delete_icon}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default InputsInputs;
